/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as LoginRouteImport } from './routes/login';
import { Route as AuthRouteImport } from './routes/_auth';
import { Route as IndexRouteImport } from './routes/index';
import { Route as AuthSectorsRouteImport } from './routes/_auth/sectors';
import { Route as AuthRedirectsRouteImport } from './routes/_auth/redirects';
import { Route as AuthIndicatorsRouteImport } from './routes/_auth/indicators';
import { Route as AuthGlossaryRouteImport } from './routes/_auth/glossary';
import { Route as AuthDocumentsRouteImport } from './routes/_auth/documents';
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard';
import { Route as AuthCategoriesRouteImport } from './routes/_auth/categories';
import { Route as AuthAnalyticsRouteImport } from './routes/_auth/analytics';
import { Route as AuthUsersIndexRouteImport } from './routes/_auth/users.index';
import { Route as AuthProjectsIndexRouteImport } from './routes/_auth/projects.index';
import { Route as AuthPagesIndexRouteImport } from './routes/_auth/pages.index';
import { Route as AuthLeadsIndexRouteImport } from './routes/_auth/leads.index';
import { Route as AuthArticlesIndexRouteImport } from './routes/_auth/articles.index';
import { Route as AuthAnalyticsIndexRouteImport } from './routes/_auth/analytics.index';
import { Route as AuthUsersIdRouteImport } from './routes/_auth/users.$id';
import { Route as AuthProjectsNewRouteImport } from './routes/_auth/projects.new';
import { Route as AuthProjectsSlugRouteImport } from './routes/_auth/projects.$slug';
import { Route as AuthPagesSlugRouteImport } from './routes/_auth/pages.$slug';
import { Route as AuthLeadsIdRouteImport } from './routes/_auth/leads.$id';
import { Route as AuthArticlesNewRouteImport } from './routes/_auth/articles.new';
import { Route as AuthArticlesSlugRouteImport } from './routes/_auth/articles.$slug';
import { Route as AuthAnalyticsGeografiaRouteImport } from './routes/_auth/analytics.geografia';
import { Route as AuthAnalyticsConversoesRouteImport } from './routes/_auth/analytics.conversoes';
import { Route as AuthAnalyticsConteudoRouteImport } from './routes/_auth/analytics.conteudo';
import { Route as AuthAnalyticsConfigRouteImport } from './routes/_auth/analytics.config';

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthSectorsRoute = AuthSectorsRouteImport.update({
  id: '/sectors',
  path: '/sectors',
  getParentRoute: () => AuthRoute,
} as any);
const AuthRedirectsRoute = AuthRedirectsRouteImport.update({
  id: '/redirects',
  path: '/redirects',
  getParentRoute: () => AuthRoute,
} as any);
const AuthIndicatorsRoute = AuthIndicatorsRouteImport.update({
  id: '/indicators',
  path: '/indicators',
  getParentRoute: () => AuthRoute,
} as any);
const AuthGlossaryRoute = AuthGlossaryRouteImport.update({
  id: '/glossary',
  path: '/glossary',
  getParentRoute: () => AuthRoute,
} as any);
const AuthDocumentsRoute = AuthDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthRoute,
} as any);
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any);
const AuthCategoriesRoute = AuthCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AuthRoute,
} as any);
const AuthAnalyticsRoute = AuthAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthRoute,
} as any);
const AuthUsersIndexRoute = AuthUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthRoute,
} as any);
const AuthProjectsIndexRoute = AuthProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AuthRoute,
} as any);
const AuthPagesIndexRoute = AuthPagesIndexRouteImport.update({
  id: '/pages/',
  path: '/pages/',
  getParentRoute: () => AuthRoute,
} as any);
const AuthLeadsIndexRoute = AuthLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AuthRoute,
} as any);
const AuthArticlesIndexRoute = AuthArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => AuthRoute,
} as any);
const AuthAnalyticsIndexRoute = AuthAnalyticsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAnalyticsRoute,
} as any);
const AuthUsersIdRoute = AuthUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AuthRoute,
} as any);
const AuthProjectsNewRoute = AuthProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => AuthRoute,
} as any);
const AuthProjectsSlugRoute = AuthProjectsSlugRouteImport.update({
  id: '/projects/$slug',
  path: '/projects/$slug',
  getParentRoute: () => AuthRoute,
} as any);
const AuthPagesSlugRoute = AuthPagesSlugRouteImport.update({
  id: '/pages/$slug',
  path: '/pages/$slug',
  getParentRoute: () => AuthRoute,
} as any);
const AuthLeadsIdRoute = AuthLeadsIdRouteImport.update({
  id: '/leads/$id',
  path: '/leads/$id',
  getParentRoute: () => AuthRoute,
} as any);
const AuthArticlesNewRoute = AuthArticlesNewRouteImport.update({
  id: '/articles/new',
  path: '/articles/new',
  getParentRoute: () => AuthRoute,
} as any);
const AuthArticlesSlugRoute = AuthArticlesSlugRouteImport.update({
  id: '/articles/$slug',
  path: '/articles/$slug',
  getParentRoute: () => AuthRoute,
} as any);
const AuthAnalyticsGeografiaRoute = AuthAnalyticsGeografiaRouteImport.update({
  id: '/geografia',
  path: '/geografia',
  getParentRoute: () => AuthAnalyticsRoute,
} as any);
const AuthAnalyticsConversoesRoute = AuthAnalyticsConversoesRouteImport.update({
  id: '/conversoes',
  path: '/conversoes',
  getParentRoute: () => AuthAnalyticsRoute,
} as any);
const AuthAnalyticsConteudoRoute = AuthAnalyticsConteudoRouteImport.update({
  id: '/conteudo',
  path: '/conteudo',
  getParentRoute: () => AuthAnalyticsRoute,
} as any);
const AuthAnalyticsConfigRoute = AuthAnalyticsConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AuthAnalyticsRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/analytics': typeof AuthAnalyticsRouteWithChildren;
  '/categories': typeof AuthCategoriesRoute;
  '/dashboard': typeof AuthDashboardRoute;
  '/documents': typeof AuthDocumentsRoute;
  '/glossary': typeof AuthGlossaryRoute;
  '/indicators': typeof AuthIndicatorsRoute;
  '/redirects': typeof AuthRedirectsRoute;
  '/sectors': typeof AuthSectorsRoute;
  '/analytics/config': typeof AuthAnalyticsConfigRoute;
  '/analytics/conteudo': typeof AuthAnalyticsConteudoRoute;
  '/analytics/conversoes': typeof AuthAnalyticsConversoesRoute;
  '/analytics/geografia': typeof AuthAnalyticsGeografiaRoute;
  '/articles/$slug': typeof AuthArticlesSlugRoute;
  '/articles/new': typeof AuthArticlesNewRoute;
  '/leads/$id': typeof AuthLeadsIdRoute;
  '/pages/$slug': typeof AuthPagesSlugRoute;
  '/projects/$slug': typeof AuthProjectsSlugRoute;
  '/projects/new': typeof AuthProjectsNewRoute;
  '/users/$id': typeof AuthUsersIdRoute;
  '/analytics/': typeof AuthAnalyticsIndexRoute;
  '/articles/': typeof AuthArticlesIndexRoute;
  '/leads/': typeof AuthLeadsIndexRoute;
  '/pages/': typeof AuthPagesIndexRoute;
  '/projects/': typeof AuthProjectsIndexRoute;
  '/users/': typeof AuthUsersIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/categories': typeof AuthCategoriesRoute;
  '/dashboard': typeof AuthDashboardRoute;
  '/documents': typeof AuthDocumentsRoute;
  '/glossary': typeof AuthGlossaryRoute;
  '/indicators': typeof AuthIndicatorsRoute;
  '/redirects': typeof AuthRedirectsRoute;
  '/sectors': typeof AuthSectorsRoute;
  '/analytics/config': typeof AuthAnalyticsConfigRoute;
  '/analytics/conteudo': typeof AuthAnalyticsConteudoRoute;
  '/analytics/conversoes': typeof AuthAnalyticsConversoesRoute;
  '/analytics/geografia': typeof AuthAnalyticsGeografiaRoute;
  '/articles/$slug': typeof AuthArticlesSlugRoute;
  '/articles/new': typeof AuthArticlesNewRoute;
  '/leads/$id': typeof AuthLeadsIdRoute;
  '/pages/$slug': typeof AuthPagesSlugRoute;
  '/projects/$slug': typeof AuthProjectsSlugRoute;
  '/projects/new': typeof AuthProjectsNewRoute;
  '/users/$id': typeof AuthUsersIdRoute;
  '/analytics': typeof AuthAnalyticsIndexRoute;
  '/articles': typeof AuthArticlesIndexRoute;
  '/leads': typeof AuthLeadsIndexRoute;
  '/pages': typeof AuthPagesIndexRoute;
  '/projects': typeof AuthProjectsIndexRoute;
  '/users': typeof AuthUsersIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/_auth': typeof AuthRouteWithChildren;
  '/login': typeof LoginRoute;
  '/_auth/analytics': typeof AuthAnalyticsRouteWithChildren;
  '/_auth/categories': typeof AuthCategoriesRoute;
  '/_auth/dashboard': typeof AuthDashboardRoute;
  '/_auth/documents': typeof AuthDocumentsRoute;
  '/_auth/glossary': typeof AuthGlossaryRoute;
  '/_auth/indicators': typeof AuthIndicatorsRoute;
  '/_auth/redirects': typeof AuthRedirectsRoute;
  '/_auth/sectors': typeof AuthSectorsRoute;
  '/_auth/analytics/config': typeof AuthAnalyticsConfigRoute;
  '/_auth/analytics/conteudo': typeof AuthAnalyticsConteudoRoute;
  '/_auth/analytics/conversoes': typeof AuthAnalyticsConversoesRoute;
  '/_auth/analytics/geografia': typeof AuthAnalyticsGeografiaRoute;
  '/_auth/articles/$slug': typeof AuthArticlesSlugRoute;
  '/_auth/articles/new': typeof AuthArticlesNewRoute;
  '/_auth/leads/$id': typeof AuthLeadsIdRoute;
  '/_auth/pages/$slug': typeof AuthPagesSlugRoute;
  '/_auth/projects/$slug': typeof AuthProjectsSlugRoute;
  '/_auth/projects/new': typeof AuthProjectsNewRoute;
  '/_auth/users/$id': typeof AuthUsersIdRoute;
  '/_auth/analytics/': typeof AuthAnalyticsIndexRoute;
  '/_auth/articles/': typeof AuthArticlesIndexRoute;
  '/_auth/leads/': typeof AuthLeadsIndexRoute;
  '/_auth/pages/': typeof AuthPagesIndexRoute;
  '/_auth/projects/': typeof AuthProjectsIndexRoute;
  '/_auth/users/': typeof AuthUsersIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/login'
    | '/analytics'
    | '/categories'
    | '/dashboard'
    | '/documents'
    | '/glossary'
    | '/indicators'
    | '/redirects'
    | '/sectors'
    | '/analytics/config'
    | '/analytics/conteudo'
    | '/analytics/conversoes'
    | '/analytics/geografia'
    | '/articles/$slug'
    | '/articles/new'
    | '/leads/$id'
    | '/pages/$slug'
    | '/projects/$slug'
    | '/projects/new'
    | '/users/$id'
    | '/analytics/'
    | '/articles/'
    | '/leads/'
    | '/pages/'
    | '/projects/'
    | '/users/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/login'
    | '/categories'
    | '/dashboard'
    | '/documents'
    | '/glossary'
    | '/indicators'
    | '/redirects'
    | '/sectors'
    | '/analytics/config'
    | '/analytics/conteudo'
    | '/analytics/conversoes'
    | '/analytics/geografia'
    | '/articles/$slug'
    | '/articles/new'
    | '/leads/$id'
    | '/pages/$slug'
    | '/projects/$slug'
    | '/projects/new'
    | '/users/$id'
    | '/analytics'
    | '/articles'
    | '/leads'
    | '/pages'
    | '/projects'
    | '/users';
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/analytics'
    | '/_auth/categories'
    | '/_auth/dashboard'
    | '/_auth/documents'
    | '/_auth/glossary'
    | '/_auth/indicators'
    | '/_auth/redirects'
    | '/_auth/sectors'
    | '/_auth/analytics/config'
    | '/_auth/analytics/conteudo'
    | '/_auth/analytics/conversoes'
    | '/_auth/analytics/geografia'
    | '/_auth/articles/$slug'
    | '/_auth/articles/new'
    | '/_auth/leads/$id'
    | '/_auth/pages/$slug'
    | '/_auth/projects/$slug'
    | '/_auth/projects/new'
    | '/_auth/users/$id'
    | '/_auth/analytics/'
    | '/_auth/articles/'
    | '/_auth/leads/'
    | '/_auth/pages/'
    | '/_auth/projects/'
    | '/_auth/users/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthRoute: typeof AuthRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AuthRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_auth/sectors': {
      id: '/_auth/sectors';
      path: '/sectors';
      fullPath: '/sectors';
      preLoaderRoute: typeof AuthSectorsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/redirects': {
      id: '/_auth/redirects';
      path: '/redirects';
      fullPath: '/redirects';
      preLoaderRoute: typeof AuthRedirectsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/indicators': {
      id: '/_auth/indicators';
      path: '/indicators';
      fullPath: '/indicators';
      preLoaderRoute: typeof AuthIndicatorsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/glossary': {
      id: '/_auth/glossary';
      path: '/glossary';
      fullPath: '/glossary';
      preLoaderRoute: typeof AuthGlossaryRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/documents': {
      id: '/_auth/documents';
      path: '/documents';
      fullPath: '/documents';
      preLoaderRoute: typeof AuthDocumentsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/dashboard': {
      id: '/_auth/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof AuthDashboardRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/categories': {
      id: '/_auth/categories';
      path: '/categories';
      fullPath: '/categories';
      preLoaderRoute: typeof AuthCategoriesRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/analytics': {
      id: '/_auth/analytics';
      path: '/analytics';
      fullPath: '/analytics';
      preLoaderRoute: typeof AuthAnalyticsRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/users/': {
      id: '/_auth/users/';
      path: '/users';
      fullPath: '/users/';
      preLoaderRoute: typeof AuthUsersIndexRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/projects/': {
      id: '/_auth/projects/';
      path: '/projects';
      fullPath: '/projects/';
      preLoaderRoute: typeof AuthProjectsIndexRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/pages/': {
      id: '/_auth/pages/';
      path: '/pages';
      fullPath: '/pages/';
      preLoaderRoute: typeof AuthPagesIndexRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/leads/': {
      id: '/_auth/leads/';
      path: '/leads';
      fullPath: '/leads/';
      preLoaderRoute: typeof AuthLeadsIndexRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/articles/': {
      id: '/_auth/articles/';
      path: '/articles';
      fullPath: '/articles/';
      preLoaderRoute: typeof AuthArticlesIndexRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/analytics/': {
      id: '/_auth/analytics/';
      path: '/';
      fullPath: '/analytics/';
      preLoaderRoute: typeof AuthAnalyticsIndexRouteImport;
      parentRoute: typeof AuthAnalyticsRoute;
    };
    '/_auth/users/$id': {
      id: '/_auth/users/$id';
      path: '/users/$id';
      fullPath: '/users/$id';
      preLoaderRoute: typeof AuthUsersIdRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/projects/new': {
      id: '/_auth/projects/new';
      path: '/projects/new';
      fullPath: '/projects/new';
      preLoaderRoute: typeof AuthProjectsNewRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/projects/$slug': {
      id: '/_auth/projects/$slug';
      path: '/projects/$slug';
      fullPath: '/projects/$slug';
      preLoaderRoute: typeof AuthProjectsSlugRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/pages/$slug': {
      id: '/_auth/pages/$slug';
      path: '/pages/$slug';
      fullPath: '/pages/$slug';
      preLoaderRoute: typeof AuthPagesSlugRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/leads/$id': {
      id: '/_auth/leads/$id';
      path: '/leads/$id';
      fullPath: '/leads/$id';
      preLoaderRoute: typeof AuthLeadsIdRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/articles/new': {
      id: '/_auth/articles/new';
      path: '/articles/new';
      fullPath: '/articles/new';
      preLoaderRoute: typeof AuthArticlesNewRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/articles/$slug': {
      id: '/_auth/articles/$slug';
      path: '/articles/$slug';
      fullPath: '/articles/$slug';
      preLoaderRoute: typeof AuthArticlesSlugRouteImport;
      parentRoute: typeof AuthRoute;
    };
    '/_auth/analytics/geografia': {
      id: '/_auth/analytics/geografia';
      path: '/geografia';
      fullPath: '/analytics/geografia';
      preLoaderRoute: typeof AuthAnalyticsGeografiaRouteImport;
      parentRoute: typeof AuthAnalyticsRoute;
    };
    '/_auth/analytics/conversoes': {
      id: '/_auth/analytics/conversoes';
      path: '/conversoes';
      fullPath: '/analytics/conversoes';
      preLoaderRoute: typeof AuthAnalyticsConversoesRouteImport;
      parentRoute: typeof AuthAnalyticsRoute;
    };
    '/_auth/analytics/conteudo': {
      id: '/_auth/analytics/conteudo';
      path: '/conteudo';
      fullPath: '/analytics/conteudo';
      preLoaderRoute: typeof AuthAnalyticsConteudoRouteImport;
      parentRoute: typeof AuthAnalyticsRoute;
    };
    '/_auth/analytics/config': {
      id: '/_auth/analytics/config';
      path: '/config';
      fullPath: '/analytics/config';
      preLoaderRoute: typeof AuthAnalyticsConfigRouteImport;
      parentRoute: typeof AuthAnalyticsRoute;
    };
  }
}

interface AuthAnalyticsRouteChildren {
  AuthAnalyticsConfigRoute: typeof AuthAnalyticsConfigRoute;
  AuthAnalyticsConteudoRoute: typeof AuthAnalyticsConteudoRoute;
  AuthAnalyticsConversoesRoute: typeof AuthAnalyticsConversoesRoute;
  AuthAnalyticsGeografiaRoute: typeof AuthAnalyticsGeografiaRoute;
  AuthAnalyticsIndexRoute: typeof AuthAnalyticsIndexRoute;
}

const AuthAnalyticsRouteChildren: AuthAnalyticsRouteChildren = {
  AuthAnalyticsConfigRoute: AuthAnalyticsConfigRoute,
  AuthAnalyticsConteudoRoute: AuthAnalyticsConteudoRoute,
  AuthAnalyticsConversoesRoute: AuthAnalyticsConversoesRoute,
  AuthAnalyticsGeografiaRoute: AuthAnalyticsGeografiaRoute,
  AuthAnalyticsIndexRoute: AuthAnalyticsIndexRoute,
};

const AuthAnalyticsRouteWithChildren = AuthAnalyticsRoute._addFileChildren(
  AuthAnalyticsRouteChildren,
);

interface AuthRouteChildren {
  AuthAnalyticsRoute: typeof AuthAnalyticsRouteWithChildren;
  AuthCategoriesRoute: typeof AuthCategoriesRoute;
  AuthDashboardRoute: typeof AuthDashboardRoute;
  AuthDocumentsRoute: typeof AuthDocumentsRoute;
  AuthGlossaryRoute: typeof AuthGlossaryRoute;
  AuthIndicatorsRoute: typeof AuthIndicatorsRoute;
  AuthRedirectsRoute: typeof AuthRedirectsRoute;
  AuthSectorsRoute: typeof AuthSectorsRoute;
  AuthArticlesSlugRoute: typeof AuthArticlesSlugRoute;
  AuthArticlesNewRoute: typeof AuthArticlesNewRoute;
  AuthLeadsIdRoute: typeof AuthLeadsIdRoute;
  AuthPagesSlugRoute: typeof AuthPagesSlugRoute;
  AuthProjectsSlugRoute: typeof AuthProjectsSlugRoute;
  AuthProjectsNewRoute: typeof AuthProjectsNewRoute;
  AuthUsersIdRoute: typeof AuthUsersIdRoute;
  AuthArticlesIndexRoute: typeof AuthArticlesIndexRoute;
  AuthLeadsIndexRoute: typeof AuthLeadsIndexRoute;
  AuthPagesIndexRoute: typeof AuthPagesIndexRoute;
  AuthProjectsIndexRoute: typeof AuthProjectsIndexRoute;
  AuthUsersIndexRoute: typeof AuthUsersIndexRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAnalyticsRoute: AuthAnalyticsRouteWithChildren,
  AuthCategoriesRoute: AuthCategoriesRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthDocumentsRoute: AuthDocumentsRoute,
  AuthGlossaryRoute: AuthGlossaryRoute,
  AuthIndicatorsRoute: AuthIndicatorsRoute,
  AuthRedirectsRoute: AuthRedirectsRoute,
  AuthSectorsRoute: AuthSectorsRoute,
  AuthArticlesSlugRoute: AuthArticlesSlugRoute,
  AuthArticlesNewRoute: AuthArticlesNewRoute,
  AuthLeadsIdRoute: AuthLeadsIdRoute,
  AuthPagesSlugRoute: AuthPagesSlugRoute,
  AuthProjectsSlugRoute: AuthProjectsSlugRoute,
  AuthProjectsNewRoute: AuthProjectsNewRoute,
  AuthUsersIdRoute: AuthUsersIdRoute,
  AuthArticlesIndexRoute: AuthArticlesIndexRoute,
  AuthLeadsIndexRoute: AuthLeadsIndexRoute,
  AuthPagesIndexRoute: AuthPagesIndexRoute,
  AuthProjectsIndexRoute: AuthProjectsIndexRoute,
  AuthUsersIndexRoute: AuthUsersIndexRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
